import get from 'lodash/get'
import React, { Component } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { NavigateFunction, useNavigate, useParams } from 'react-router-dom'
import type { State } from 'types/redux'
import { sortPlaylistTracks } from '@disco/state-management/actions/PlaylistTrackActions'
import { getPlaylist } from '@disco/state-management/selectors/playlists'
import TrackOrderModal from 'components/modals/track-order'
import type { RootState } from 'store/configureStore'
interface OwnProps {
  params: {
    playlistId: string
  }
  navigate: NavigateFunction
}

function mapStateToProps(state: RootState, { params }: OwnProps) {
  return {
    playlist: getPlaylist(state, {
      id: parseInt(params.playlistId, 10),
    }),
  }
}

const mapDispatchToProps = {
  sortPlaylistTracks,
}

const connector = connect(mapStateToProps, mapDispatchToProps)

type PropsFromRedux = ConnectedProps<typeof connector>
type PlaylistTrackOrderProps = PropsFromRedux & OwnProps

class PlaylistTrackOrder extends Component<PlaylistTrackOrderProps> {
  _onClose = () => {
    this.props.navigate('/')
  }
  _onChange = (sortKey, sortDirection) => {
    this.props.sortPlaylistTracks(this.props.playlist, sortKey, sortDirection)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const nextSortingStatus = get(
      nextProps,
      'playlist.actionStatus.sorting',
      false,
    )
    const currentSortingStatus = get(
      this.props,
      'playlist.actionStatus.sorting',
      false,
    )

    if (currentSortingStatus && !nextSortingStatus) {
      this._onClose()
    }
  }

  render() {
    const { sort_key, sort_direction } = this.props.playlist
    const actionStatus = (this.props.playlist as any).actionStatus
    const sorting =
      sort_key !== 'custom' ? `${sort_key};${sort_direction}` : sort_key
    const sortingInProgress = actionStatus && actionStatus.sorting
    return (
      <TrackOrderModal
        onClose={this._onClose}
        onChange={this._onChange}
        currentSorting={sorting}
        progressIndicator={sortingInProgress}
      />
    )
  }
}

const ConnectedPlaylistTrackOrder = connector(PlaylistTrackOrder)

// Wrapper component to provide navigation to the connected component
const PlaylistTrackOrderWithRouter = (props: any) => {
  const navigate = useNavigate()
  const params = useParams<{ playlistId: string }>()
  return (
    <ConnectedPlaylistTrackOrder
      {...props}
      navigate={navigate}
      params={params}
    />
  )
}

export default PlaylistTrackOrderWithRouter
